// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpDesignSystemProvider } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const DesignSystemProvider = wrap(jpDesignSystemProvider());
// @ts-expect-error unknown property
DesignSystemProvider.displayName = 'Jupyter.DesignSystemProvider';
